import React from 'react';

import XLSX from 'xlsx';

import { toastr } from 'react-redux-toastr';

import { Row } from 'xpi-black-ui/Base/Grid';
import Button from 'xpi-black-ui/Base/Button';

import waConfig from 'utils/waConfig';

import { Input, Tag } from './styles';

const UploadClients = ({ showMessageDisabledButton, loadClientsFromExcel, disableButtons }) => {
  const isValidType = (file) => {
    const types = ['.sheet', '.xls', '.xlsx', 'xlsm'];

    return types.some(type => file.type.includes(type))
    || types.some(name => file.name.includes(name))
  };

  const convertFileToJson = (file) => {
    const reader = new FileReader();

    reader.readAsBinaryString(file);
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, {type: 'binary'});
      const XLRow = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
        header: 1,
        raw: false,
        blankrows: false,
      });

      let json = JSON.stringify(XLRow);
      json = JSON.parse(json);
      json.shift();

      const items = json.map(item => ({
        clientId: Number(item[0]) || 0,
        quantity: Number(item[1]) || 0,
      }));

      loadClientsFromExcel(items);
    };

    reader.onerror = () => {
      toastr.error('Arquivo inválido', 'Utilize a planilha modelo ');
    };
  };

  const onLoadFile = (file) => {
    const typeIsValid = isValidType(file);

    if (typeIsValid) {
      convertFileToJson(file);
    } else {
      toastr.error('Formato inválido', 'Você deve importar um arquivo do formato .xlsx');
    }
  };

  return (
    <Tag>
      <Row>
        <Button disabled={disableButtons} data-wa={waConfig.event.acquisition.importBaskClients}>Importar Excel</Button>
        <Input
          type="file"
          onChange={e => {
            onLoadFile(e.target.files[0]);
            e.target.value = null;
          }}
        />

        {showMessageDisabledButton && (
          <p style={{ marginLeft: '10px'}}>Funcionalidade não disponível para esse ativo</p>
        )}
      </Row>
    </Tag>
  );
};

export default UploadClients;
